export default "__VITE_PUBLIC_ASSET__2a8e5b10__"